import { useEffect, useState } from "react";
import LText from "@components/LText";
import LBox from "@components/LBox";
import { Image, Dimensions } from "react-native";
import { fonts } from "@theme";
import { router } from "expo-router";
import { trackOnb } from "@components/Onboarding/analytics/trackOnboarding";
import IntroLayout from "@components/Onboarding/Intro/IntroLayout";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  Easing,
} from "react-native-reanimated";

const bgImage = require("@assets/onboarding/aha3.webp");
const SCREEN_W = Dimensions.get("window").width;
// Match aha2's image height: width * (1131/537)
const AHA_IMG_W = SCREEN_W * 0.65;
const AHA_IMG_H = AHA_IMG_W * (1131 / 537);
const ANIM_DURATION = 500;
const STEP_DELAY = 600;
const EASING = Easing.out(Easing.cubic);

export default function Aha3() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    trackOnb("signup", "aha-3", "view");
    const t1 = setTimeout(() => setStep(1), 200);
    const t2 = setTimeout(() => setStep(2), 200 + STEP_DELAY);
    const t3 = setTimeout(() => setStep(3), 200 + STEP_DELAY * 2);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  const segO = useSharedValue(0);
  const segY = useSharedValue(40);
  const hlO = useSharedValue(0);
  const hlY = useSharedValue(30);
  const bodyO = useSharedValue(0);
  const bodyY = useSharedValue(20);

  useEffect(() => {
    if (step >= 1) {
      segO.value = withTiming(1, { duration: ANIM_DURATION, easing: EASING });
      segY.value = withTiming(0, { duration: ANIM_DURATION, easing: EASING });
    }
    if (step >= 2) {
      hlO.value = withTiming(1, { duration: ANIM_DURATION, easing: EASING });
      hlY.value = withTiming(0, { duration: ANIM_DURATION, easing: EASING });
    }
    if (step >= 3) {
      bodyO.value = withTiming(1, { duration: ANIM_DURATION, easing: EASING });
      bodyY.value = withTiming(0, { duration: ANIM_DURATION, easing: EASING });
    }
  }, [step, segO, segY, hlO, hlY, bodyO, bodyY]);

  const segStyle = useAnimatedStyle(() => ({
    opacity: segO.value,
    transform: [{ translateY: segY.value }],
  }));
  const hlStyle = useAnimatedStyle(() => ({
    opacity: hlO.value,
    transform: [{ translateY: hlY.value }],
  }));
  const bodyStyle = useAnimatedStyle(() => ({
    opacity: bodyO.value,
    transform: [{ translateY: bodyY.value }],
  }));

  return (
    <IntroLayout
      totalSteps={4}
      currentStep={3}
      buttonLabel="Continue"
      buttonEventName="aha_3"
      onButtonPress={() => router.navigate("/onboarding/aha-4")}
    >
      <Image
        source={bgImage}
        style={{
          position: "absolute",
          right: -16,
          top: "55%",
          height: AHA_IMG_H,
          width: AHA_IMG_H * (378 / 1044),
          transform: [{ translateY: "-50%" }],
        }}
        resizeMode="contain"
      />

      <LBox flex={1} justifyContent="center" alignItems="center">
        <Animated.View style={[segStyle, { marginBottom: 36, width: "100%" }]}>
          <LText
            variant="Heading/H1/Medium"
            textAlign="center"
            color="white"
            style={{ textShadowColor: "rgba(0,0,0,0.6)", textShadowOffset: { width: 0, height: 1 }, textShadowRadius: 4 }}
          >
            {"The good news:\nLissen will send"}
          </LText>
        </Animated.View>

        <Animated.View style={hlStyle}>
          <LText
            fontSize={80}
            fontFamily={fonts.extraBold}
            textAlign="center"
            lineHeight={80}
            style={{ color: "#4ADE80", letterSpacing: -0.03 * 80, textShadowColor: "rgba(0,0,0,0.8)", textShadowOffset: { width: 0, height: 2 }, textShadowRadius: 8 }}
          >
            100%
          </LText>
        </Animated.View>

        <Animated.View style={[bodyStyle, { marginTop: 36, width: "100%" }]}>
          <LText
            variant="Heading/H1/Medium"
            textAlign="center"
            color="white"
            style={{ textShadowColor: "rgba(0,0,0,0.6)", textShadowOffset: { width: 0, height: 1 }, textShadowRadius: 4 }}
          >
            {"of that money only to artists you\nstream, while rewarding you."}
          </LText>
        </Animated.View>
      </LBox>

      <LText
        fontSize={13}
        fontFamily={fonts.regular}
        lineHeight={18}
        textAlign="center"
        color="whiteTranslucent60"
        mb="s3"
      >
        {"According to your profile combined with\nLissen\u2019s model."}
      </LText>
    </IntroLayout>
  );
}
